export enum SubscriptionFilterType {
  STEP = 'STEP',
  HOLDING_METHOD = 'HOLDING_METHOD',
  IDENTITY_TYPE = 'IDENTITY_TYPE',
  CUSTOM = 'CUSTOM',
  STATUS = 'STATUS',
  TAGS = 'TAGS',
}
